import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { CreateRouteAtoBRequest, RouteCreationResponse } from '../types';

export function useCreateRouteAtoB() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateRouteAtoBRequest) =>
      apiClient.post<RouteCreationResponse>('/routes', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.routes.all });
    },
  });
}
